<template>
    <div class="flex items-center space-x-4">
        <!-- Theme Toggle -->
        <button
            @click="toggleDarkMode"
            class="p-2 text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300"
        >
            <SunIcon v-if="darkMode" class="h-5 w-5"/>
            <MoonIcon v-else class="h-5 w-5"/>
        </button>

        <!-- Notifications -->
        <button v-if="auth?.user" class="rounded-full p-2 text-slate-400 hover:text-slate-500 dark:hover:text-slate-300">
            <BellIcon class="h-5 w-5"/>
        </button>
    </div>
</template>

<script setup>
import {ref, onMounted} from 'vue'
import {usePage} from '@inertiajs/vue3'
import {SunIcon, MoonIcon, BellIcon} from '@/Components/Icons'

const darkMode = ref(false)
const page = usePage()
const auth = page.props.auth

onMounted(() => {
    try {
        darkMode.value = document.documentElement.classList.contains('dark')
    } catch (e) {
        console.warn('Could not access document element')
    }
})

const toggleDarkMode = () => {
    try {
        darkMode.value = !darkMode.value
        document.documentElement.classList.toggle('dark')
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem('darkMode', darkMode.value)
        }
    } catch (e) {
        console.warn('Could not toggle dark mode')
    }
}
</script>
